// custom filter desktop and mobile script

document.addEventListener("DOMContentLoaded", function() {
  
  const collectionContainerSelector = '[js-collection-products-wrapper]';
  const filterDesktopForm = '[js-cus-desktop-filter-form]';
  const filterMobileForm = '[js-cus-mobile-filter-form]';
  const filterItemWrapper = '[js-cus-product-filter]';
  const filterLableSelector = '[js-cus-filter-label]';
  const filterListSelector = '[js-cus-filter-list]';
  const filterOptionInput = '[js-cus-option-input]';
  const clearAllFiltersSelector = '[js-cus-clear-all-filters]';
  const activeFiltersSelector = '[js-cus-active-filters]';
  const removeFilterSelector = '[js-cus-active-filter-remove]';
  const collectionSelector = '[js-cus-collection]';

  const mobileFilterDrewerCTASelector = "[js-cus-drawer-cta]";
  const mobileFilterDrewerCloseCTASelector = "[js-cus-drawer-close-cta]";
  const filterDrewerSelector = "[js-cus-mobile-filter-drawer]";

  const filterAccordionSelector = "[js-cus-filter-accordion]";
  const filterAccordionHeaderSelector = "[js-cus-filter-accordion-header]";

  const mobileColorSwitcherWraperSelector = "[js-cus-mobile-color-switcher]";
  const desktopColorSwitcherWraperSelector = "[js-cus-desktop-color-switcher]";

  const customCardSelector = "[js-cus-custom-card]";
  const productItemSelector = "[js-cus-product]";
  const productListSelector = "[js-cust-product-list]"

  const colorGroupItemSwitcherSelector = "[js-filter-color]";
  const colorGroupSelector = "[js-color-group]";
  const colorInputSelector = "[js-color-input]";

  initFun();

  function customCardEmbaded(){
    document.querySelectorAll(customCardSelector).forEach(customCard => {
      const desktopCardPosition = +customCard.dataset.desktopCardPosition - 1;
      const mobileCardPosition = +customCard.dataset.mobileCardPosition - 1;
      
      if(window.innerWidth < 768){
        document.querySelector(productListSelector)?.insertBefore(customCard.cloneNode(true), document.querySelectorAll(productItemSelector)[mobileCardPosition])
      } else {
        document.querySelector(productListSelector)?.insertBefore(customCard.cloneNode(true), document.querySelectorAll(productItemSelector)[desktopCardPosition])
      }
    })
  }

  function replaceUrlHistory (url, query, extra){
    if(query){
      url = `${url}?${query}`
    } else {
      url = `${url}`
    }
    if(extra){
      url = `${url}${extra}`
    }
    window.history.pushState('','', url)
  }

  function fetchData(url, query, extra){
    replaceUrlHistory(url, query, extra)
    if(query){
      url = `${url}?view=ajax&${query}`
    } else {
      url = `${url}?view=ajax`
    }
    if(extra){
      url = `${url}${extra}`
    }

    fetch(url)
      .then(response => {
        return response.text()
      })
      .then(doc => {
        const parser = new DOMParser()
        const html = parser.parseFromString(doc, 'text/html')
        const ajaxCollection = html.querySelector(collectionContainerSelector)
        document.querySelector(collectionContainerSelector).replaceWith(ajaxCollection)
        // Re-apply mobile drawer closed state after AJAX render
        const drawer = document.getElementById('mobile-filter-drawer');
        const trigger = document.querySelector(mobileFilterDrewerCTASelector);
        if (drawer && trigger) {
          drawer.setAttribute('aria-hidden', 'true');
          drawer.setAttribute('inert', '');
          drawer.hidden = true;
          trigger.setAttribute('aria-expanded', 'false');
        }
        if(!query && ajaxCollection.querySelector('[js-cus-product]')){
          customCardEmbaded();
        }


        // on key filters 


      })
  }

  function showActiveFilters(formData){
    document.querySelector(clearAllFiltersSelector).style.display = 'none';
    const activeFilters = [];
    const activeFilterWrapper = document.querySelector(activeFiltersSelector);
    activeFilterWrapper.innerHTML = '';
    for (const entry of formData.entries()) {
      if(entry[0] !== "sort_by" && entry[1] !== "1"){
        activeFilters.push(entry[1]);
      }
    }

    activeFilters.reverse().forEach(item => {
      activeFilterWrapper.insertAdjacentHTML('afterbegin', `
        <div class="active-filter">
          <span class="label">${item}</span>
          <span class="filter-remove-cta" data-label="${item}" js-cus-active-filter-remove >
              <svg xmlns="http://www.w3.org/2000/svg" width="7" height="7" viewBox="0 0 7 7" fill="none">
                  <g id="Group 446">
                  <path id="Vector" d="M6.25 1L1 6.25" stroke="white" stroke-linecap="square"/>
                  <path id="Vector_2" d="M1 1L6.25 6.25" stroke="white" stroke-linecap="square" stroke-linejoin="round"/>
                  </g>
              </svg>
          </span>
      </div>`)

      if(activeFilters.length){
        document.querySelector(clearAllFiltersSelector).style.display = 'inline-block';
      }
      
    })

  }

  function collectionFilter(formTag){
    const formData = new FormData(document.querySelector(formTag));
    showActiveFilters(formData);

    const queryString = new URLSearchParams(formData).toString();
    const url = `${location.origin}${location.pathname}`;
    let extra = false

    if (
      queryString?.length > 0 &&
      !queryString.includes('filter.v.availability=1')
    ) {
      extra = '&filter.v.availability=1'
    }

    fetchData(url, queryString, extra)
  }

  function initFun(){
    customCardEmbaded();
  }

    // Mobile drawer accessibility helpers
  function openMobileFilterDrawer() {
    const drawerWrapper = document.querySelector(filterDrewerSelector); // [js-cus-mobile-filter-drawer]
    const drawer = document.getElementById('mobile-filter-drawer');
    const trigger = document.querySelector(mobileFilterDrewerCTASelector);

    if (!drawerWrapper || !drawer || !trigger) return;

    // Visual open (existing behavior)
    drawerWrapper.classList.add('filter-open');

    // Accessibility open
    drawer.hidden = false;
    drawer.setAttribute('aria-hidden', 'false');
    drawer.removeAttribute('inert');
    trigger.setAttribute('aria-expanded', 'true');

    // Move focus inside the dialog
    const closeBtn = drawer.querySelector(mobileFilterDrewerCloseCTASelector);
    requestAnimationFrame(() => {
      (closeBtn || drawer).focus();
    });
  }

  function closeMobileFilterDrawer() {
    const drawerWrapper = document.querySelector(filterDrewerSelector);
    const drawer = document.getElementById('mobile-filter-drawer');
    const trigger = document.querySelector(mobileFilterDrewerCTASelector);

    if (!drawerWrapper || !drawer || !trigger) return;

    // Visual close (existing behavior)
    drawerWrapper.classList.remove('filter-open');

    // Accessibility close (hide from screen readers)
    drawer.setAttribute('aria-hidden', 'true');
    drawer.setAttribute('inert', '');
    drawer.hidden = true;
    trigger.setAttribute('aria-expanded', 'false');

    // Return focus to the trigger
    trigger.focus();
  }

  // Ensure initial closed state is enforced (prevents SR from reading hidden drawer on load)
  (function enforceMobileDrawerClosedOnLoad() {
    const drawer = document.getElementById('mobile-filter-drawer');
    const trigger = document.querySelector(mobileFilterDrewerCTASelector);
    if (!drawer || !trigger) return;

    drawer.setAttribute('aria-hidden', 'true');
    drawer.setAttribute('inert', '');
    drawer.hidden = true;
    trigger.setAttribute('aria-expanded', 'false');
  })();


  // collection filters accessibility

  document.addEventListener('click', function(e){

    document.querySelectorAll(filterAccordionHeaderSelector).forEach(accordionHeader => {
      if(accordionHeader.contains(e.target)){
        const parent = accordionHeader.closest(filterAccordionSelector);
        if(parent.classList.contains('open')) {
          parent.classList.remove('open');
        } else {
          document.querySelectorAll(filterAccordionSelector).forEach(accordion => {
            accordion.classList.remove('open');
          })
          parent.classList.add('open');
        }
      }
    })

    const mobileFilterDrawerCta = document.querySelector(mobileFilterDrewerCTASelector);
    const mobileFilterDrewerCloseCTA = document.querySelector(mobileFilterDrewerCloseCTASelector);

    if (mobileFilterDrawerCta?.contains(e.target)) {
      openMobileFilterDrawer();
    }

    if (mobileFilterDrewerCloseCTA?.contains(e.target)) {
      closeMobileFilterDrawer();
    }


    document.querySelectorAll(collectionSelector).forEach(collection => {  
      if(collection.contains(e.target)) {

        document.querySelectorAll(collectionSelector).forEach(collection_ => {
          collection_.classList.remove('selected');
        })

        collection.classList.add('selected'); 

        let selectedSliderIndex = $('.collection_list_slider_new .selected').index();

        collection_list_slider_new.slideTo(selectedSliderIndex, 1000)

        const url = `${location.origin}${collection.getAttribute('data-collection-url')}`;
    
        fetchData(url)
      }
    })

    document.querySelectorAll(filterItemWrapper).forEach(filterItem => {
      if(!filterItem.contains(e.target)){
        filterItem.classList.remove('selected');
      }
    })

    document.querySelectorAll(filterLableSelector).forEach(filterLabel => {
      if(filterLabel.contains(e.target)){
        const parent = filterLabel.closest(filterItemWrapper);
        if(!parent.classList.contains('selected')) {
          parent.classList.add('selected');
        } else {
          parent.classList.remove('selected');
        }
      }
    })

    document.querySelectorAll(filterListSelector).forEach(filterList => {
      if(filterList.contains(e.target)){
        const parent = filterList.closest(filterItemWrapper);
        parent.classList.add('selected');
      }
    })

    document.querySelectorAll(removeFilterSelector).forEach(btn => {
      if(btn.contains(e.target)){
        document.querySelectorAll(filterOptionInput).forEach(input => {
          if(input.value == btn.getAttribute('data-label')) {
            input.checked = false;
            if(document.querySelector(filterDesktopForm)){
              collectionFilter(filterDesktopForm)
            } else {
              collectionFilter(filterMobileForm)
            }
          }
        })
      }
    })

    document.querySelectorAll(clearAllFiltersSelector).forEach(btn => {
      if(btn.contains(e.target)){
        document.querySelectorAll(filterOptionInput).forEach(filterInput => {
          if(filterInput.checked){
            filterInput.checked = false
          }
        })

        if(document.querySelector(filterDesktopForm)){
          collectionFilter(filterDesktopForm)
        } else {
          collectionFilter(filterMobileForm)
        }

      }
    })

    document.querySelectorAll(filterOptionInput).forEach(filterInput => {
      if (filterInput === e.target) {
        if(document.querySelector(filterDesktopForm)){
          collectionFilter(filterDesktopForm)
        } else {
          collectionFilter(filterMobileForm)
        }
        
      }
    })
   
  });

    document.addEventListener('keydown', function(e) {
    if (e.key !== 'Escape') return;

    const drawerWrapper = document.querySelector(filterDrewerSelector);
    if (drawerWrapper?.classList.contains('filter-open')) {
      e.preventDefault();
      closeMobileFilterDrawer();
    }
  });


});
